import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import MLIcon from '../../../../../../components/MLIcon/MLIcon';
import {
  WIDGET_TYPE_TIME_SCORE_CHART,
  WIDGET_TYPE_TIME_ATTEMPTS_CHART,
  WIDGET_TYPE_COMPLETED_ASSIGNMENT,
} from '../../../../constants';
import style from './QQHeader.module.css';

const QQHeader = ({
  title,
  subTitle,
  subTitle2,
  iconType,
  isDetailView,
  showInsightInfo,
  widgetType,
  preventFixedHeight,
  preventWidthOverflow,
  isSRLWidget,
}) => {
  const detailClass = isDetailView ? style.detailView : '';

  useEffect(() => {
    setTimeout(() => {
      ReactTooltip.rebuild();
    }, 800);
  }, []);


  const renderInfoIcon = () => {
    const showInfoIcon = [
      WIDGET_TYPE_TIME_SCORE_CHART,
      WIDGET_TYPE_TIME_ATTEMPTS_CHART,
      WIDGET_TYPE_COMPLETED_ASSIGNMENT,
    ].includes(widgetType);

     // This prevents multiple renders of the tooltip
     const randomKey = Math.random().toString(36).substring(7);

    if (showInfoIcon) {
      return (
        <>
          <MLIcon
            type="info_outline"
            role="button"
            onClick={() => showInsightInfo()}
            data-for={`info-button-${randomKey}`}
            data-tip="How is this calculated?"
            className={style.infoTooltip}
          />
          <ReactTooltip
            id={`info-button-${randomKey}`}
            place="left"
            className={style.infoTooltip}
            effect="solid"
          />
        </>
      );
    }
    return null;
  };



  return (
    <React.Fragment>
      <div className={`${style.qqInsightsCardTitleWrapper} ${detailClass} ${preventFixedHeight ? style.autoHeight : ''} ${preventWidthOverflow && style.boxSizing}`}>
        <div className={style.qqInsightsCardTitleIcon}>
          <MLIcon
            width="24px"
            height="24px"
            className={style.thinkIcon}
            type={iconType}
          />
        </div>
        <div className={style.qqInsightsCardTitleTextWrapper}>
          <div className={style.qqInsightsCardTitle} title={title}>
            <div className={style.qqInsightsCardMainTitle}>
              <h2 className={`${isSRLWidget ? style.qqInsightsCardMainTitleBold : ''}`}>
                {title}
              </h2>
              <div className={style.qqInsightsCardSubTitle} id="insights-card-subheader">
                {subTitle}
                <div>{subTitle2}</div>
              </div>
            </div>
            {renderInfoIcon()}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

QQHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  subTitle2: PropTypes.node,
  iconType: PropTypes.string,
  isDetailView: PropTypes.bool,
  showInsightInfo: PropTypes.func,
  widgetType: PropTypes.string,
  preventFixedHeight: PropTypes.bool,
  preventWidthOverflow: PropTypes.bool,
  isSRLWidget: PropTypes.bool,
};

export default QQHeader;
